<div
    class="bp-spacer"
    [style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
  >
    <div
      class="bp-image-spacer-holder"
	  [style.padding]="data.page_spacer.spacer_size + 'px'"
    ></div>
  </div>